class Result {
  constructor(data, error, headers = null, status = null, message = '') {
    this.data = data;
    this.error = error;
    this.headers = headers;
    this.status = status;
    this.message = message;
  }
}

export default {
  methods: {
    _handleResponse(promise) {
      return promise.then(
        // Success
        function(result) {
          return new Result(result.body || result.data, null, result.headers, result.status);
        },
        // Failure
        function(error) {
          const message = (error.body && error.body.message) ? error.body.message : '';
          const err = Error(`Error: Code ${error.status}, Status: ${error.statusText}, Message: ${message}`);
          return new Result(null, err, error.headers || null, error.status, message);
        }
      );
    },

    post: function (url, data, options = null) {
      return this._handleResponse(this.$http.post(url, data, options));
    },
    put: function (url, data, options = null) {
      return this._handleResponse(this.$http.put(url, data, options));
    },
    get: function (url, options = {}) {
      return this._handleResponse(this.$http.get(url, options));
    },
    delete: function (url, data, options = null) {
      return this._handleResponse(this.$http.delete(url, data, options));
    },
    getFile: function (url, options = {}) {
      const defaultOptions = {
        responseType: 'blob',
        cache: 'reload',
        headers: {
          'Cache-Control': 'max-age=0, must-revalidate'
        }
      };
      return this._handleResponse(this.$http.get(url, { ...defaultOptions, ...options }));
    },
    postFile: function (url, data, options = {}) {
      const defaultOptions = {
        responseType: 'blob',
        cache: 'reload',
        headers: {
          'Cache-Control': 'max-age=0, must-revalidate'
        }
      };
      return this._handleResponse(this.$http.post(url, data, { ...defaultOptions, ...options }));
    },

    makeSearchParams(data) {
      let params = new URLSearchParams()

      if (data == null) {
        return params;
      }
      if (data.page) {
        params.set("page", data.page);
      }
      if (data.size) {
        params.set("size", data.size);
          }
      if (data.query) {
        params.set("query", data.query);
        }
      return params;
    },
    makeSortParams(data) {
      if (!data) return '';

      if (!data.sortBy) return '';

      const sortByIds = data.sortBy.map(function (item) {
        return "&sort_by[]=" + item;
      });
      const sortBy = sortByIds.join('');

      const sortDescIds = data.sortDesc.map(function (item) {
        return "&order[]=" + (item ? 'desc' : 'asc');
      });
      const sortDesc = sortDescIds.join('');

      return `${sortBy}${sortDesc}`;
    },
    getDateToServer(date) {
      return new Date(date);
    },
    handleFileDownload(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    /*
    // pdf converter
    async postDocxFiles(fileName, file) {
      let formData = new FormData();
      formData.append('file', file, fileName);

      let res = new Result();
      const url = "converter";

      const options = {
        responseType: 'blob',
        cache: 'reload',
        headers: {
          'Cache-Control': 'max-age=0, must-revalidate'
        }
      }
      await this.postFile(url, formData, options, function (response) {
        res.data = response.data;
      }.bind(this), error => {
        res.error = Error(`Error: Code ${error.status}, Text: ${error.statusText}`);
      });
      return res;
    },
     */
  }
}



// WEBPACK FOOTER //
// ./src/network/api.js